// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from '@/app'

// Vuex store
import store from '@/vuex/store.js'

// vuetify-mask
import './plugins/vuetify-mask.js'

// We will use Vuetify to make a gorgeous interface :)
import Vuetify from 'vuetify'
Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#00796b',
        secondary: '#b0bec5'
      }
    }
  }
})

// Choose either axios + vue-axios or vue-resource. Both use 'this.$http' call,
// but only vue-resource accepts the 'finally' clause. So, if changing from vue-resource
// to axios, be careful about places where the clause 'finally' is being used
import VueResource from 'vue-resource'
Vue.use(VueResource)

// import axios from 'axios'
// import VueAxios from 'vue-axios'
// Vue.use(VueAxios, axios)

// Moment.js for data formatting
// Will add moment to Vue instance so it can be used anywhere without polluting the core scope
import moment from 'moment'
moment.locale('pt-br')
Vue.prototype.moment = moment

// Router (Vue-router)
import router from '@/router'

// Auth for existent authentication check before creating the app
// import auth from '@/utils/auth'

// Stop the browser from dealing with basic auth (its darn ugly login popup won't popup anymore)
Vue.http.headers.common['X-Requested-With'] = 'XMLHttpRequest'

// Redirecting all unauthorized request to the login page, no matter the origin
// Should we create pages for other errors too (like 404)?
Vue.http.interceptors.push((request, next) => {
  next((response) => {
    if (response.status === 401) {
      store.dispatch('auth/UNSET_LOGGED_IN')
      store.dispatch('auth/UNSET_USERNAME')
      router.push({name: 'Login'})
    }
  })
})

// Vuetify styles
require('@/../node_modules/vuetify/dist/vuetify.min.css')
require('@/../node_modules/font-awesome/css/font-awesome.min.css')
/* eslint-disable no-new */
new Vue({
  router,
  store,
  el: '#app',
  template: '<app/>',
  components: { App },
  vuetify: new Vuetify()
})



// WEBPACK FOOTER //
// ./src/main.js